import {Box,Table,Thead,Tbody,Tr,Th,Td,TableContainer,  Text, Center, Spacer,Icon} from '@chakra-ui/react'
import {useState } from 'react'
import { MdCheckBox,MdCheckBoxOutlineBlank } from 'react-icons/md';
//import {  colorSchmemes, loggedOper as lp, userCanEdit } from '../../util/grunt';
import GruntPager from '../custom/GruntPager';


export default function PopisGovedaTable({popisGoveda,onSelectPopis,tableSize='xs',readonly=false}) {
    const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",rowsperpage:22,currpage:1});
    

    const ShowGruntPager=()=>{
        if (popisGoveda.length>0) {
            return (
                <GruntPager currpage={prikaz.currpage} rowcount={popisGoveda.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                );    
        }
        
    }

    const getNaSpecifikaciji=(naspec)=>{
        if (naspec!==0) {
          return <Icon as={MdCheckBox}  boxSize={5}/>
        } else {
          return <Icon as={MdCheckBoxOutlineBlank} boxSize={5}/>
        }
        }
    const showPopisGoveda=()=>{
        
            return (
                <Box display={'flex'} flexDir={'column'} flex={1}>
                    <TableContainer >
                        <Table variant={'unstyled'} size={tableSize}>
                            <Thead _hover={{cursor:'pointer'}} fontSize={tableSize}>
                                <Tr>
                                    <Th w={'2%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rbr</Th>
                                    <Th w={'8%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Šifra</Th>
                                    <Th w={'20%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Naziv</Th>
                                    <Th w={'20%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Operater</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Broj zapisa</Th>
                                    <Th w={'20%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Boks</Th>
                                    <Th w={'5%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Specifikacija</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            {popisGoveda.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                                 return (
                                    <Tr  color={'grunt2'} key={`pop${i}`}  bg={'white'} fontWeight={'normal'} 
                                    _hover={{bg:'gray.100',cursor:'pointer'}} h='2rem' onClick={(id)=>onSelectPopis(item.rgg_id)}>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                            {`${(i+1)+((prikaz.currpage-1)*prikaz.rowsperpage)}.`}
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>{item.rgg_id}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>{item.naziv}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                                {item.pasmina}
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                                {item.operater}
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                            {new Date(item.datum.toString().split('T')[0]).toLocaleDateString('hr-HR')}
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{item.br_goveda}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                            <Box display={'flex'} flexDir={'column'}>
                                                <Text fontSize={'10px'}>{item.lokacija} / {item.toviliste}</Text>
                                                
                                                <Text fontWeight={'bold'} fontSize={'10px'}>{item.odjeljak}</Text>
                                            </Box>
                                            
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                            {getNaSpecifikaciji(item.specifikacija_id)}
                                            
                                        </Td>
                                    </Tr>
                                 )
                            })}
                            </Tbody>
                            </Table>
                    </TableContainer>
                    
            </Box>
            )    
    
        
    }
    const getFooter=()=>{
        return (
            
            <Box flexDir={'row'} display={'flex'} w="100%" alignItems={'center'} h={'40px'} >
                
                <Box w="25%">
                    {showBrZapis()}
                </Box>
                <Box w="50%">
                    <Center>
                        {ShowGruntPager()}
                    </Center>
                </Box>
                <Box w="25%">
                    
                </Box>
            </Box>
            
        )
      }
      const showBrZapis=()=>{
        return (
          <Text fontSize={'xs'}>Prikazano zapisa: {popisGoveda.length}</Text>
        )
      }
    
  return (
    <Box display={'flex'} flexDir={'column'} flex={1} w={'100%'}>
        
        {showPopisGoveda()}
        
        <Spacer/>
        {getFooter()}
    </Box>
  )
}
